import { render, staticRenderFns } from "./StatementCommentRemove.vue?vue&type=template&id=9c93a3cc&"
import script from "./StatementCommentRemove.vue?vue&type=script&lang=js&"
export * from "./StatementCommentRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports